module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/violation-report/violation-report.component.css
// module id = ./src/app/violation-report/violation-report.component.css
// module chunks = main